import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      navigate(user.role === "admin" ? "/admin" : "/tableau-de-bord");
    } catch (err) {
      setError(formatApiError(err, "Connexion impossible."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center gap-2 mb-8">
          <img src="/assets/logo-auth.png" alt="Mindset'iMMO" className="h-16 w-auto" data-testid="auth-logo" />
          <p className="text-sm text-slate-500">Portail</p>
        </div>
        <Card className="border-slate-200 shadow-sm">
          <CardHeader>
            <CardTitle className="font-heading text-xl" data-testid="login-title">Connexion</CardTitle>
            <CardDescription>Accède à tes applications et tes crédits.</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && (
                <div className="bg-orange-50 border border-orange-200 text-orange-800 text-sm rounded-lg px-4 py-3" data-testid="login-error">
                  {error}
                </div>
              )}
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="ton@email.fr" data-testid="login-email-input" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="password">Mot de passe</Label>
                <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="login-password-input" />
              </div>
              <Button type="submit" className="w-full bg-teal-600 hover:bg-teal-700" disabled={loading} data-testid="login-submit-button">
                {loading ? "Connexion..." : "Se connecter"}
              </Button>
            </form>
            <div className="mt-4 text-center space-y-2">
              <Link to="/mot-de-passe-oublie" className="text-sm text-teal-700 hover:underline block" data-testid="forgot-password-link">
                Mot de passe oublié ?
              </Link>
              <p className="text-sm text-slate-600">
                Pas encore de compte ?{" "}
                <Link to="/inscription" className="text-teal-700 font-medium hover:underline" data-testid="register-link">
                  Créer un compte
                </Link>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
